/* transilations & languages */
export const TRANSILATIONS = "transilations";
export const LANGUAGE_ID="language"